import React from 'react';
import Waiter from "../../controls/Waiter.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import appLib from "../../libs/appLib.mjs";
import {Glob as G} from "../../libs/Glob.mjs";

const WeekDay = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			weekday : String(props.weekday ?? (new Date()).getDay())
		};
		this.uid = G.generateUid('WeekDay');
		this.load = this.load.bind(this);
	}
	componentDidMount() {
		setTimeout( this.load );
	}
	async load() {
		try {
			const data = await appLib.data('weekly');
			this.setState({ data: data, loaded: true });
		} catch (e) {
			setTimeout( this.load, 3000 );
		}
	}
	render() {
		if ( ! this.state.data ) {
			return(
				<div className={"text-center"}>
					<Waiter />
				</div>
			);
		}
		const l = (this.state.data||[]).filter( i => (! i.disabled && (i.weekday === this.state.weekday)));
		return(
			<div className={"WeekDay"} id={this.uid}>
				{ l.length ? l.map(( l, i ) => (
					<div key={ i }>
						{ l.msg }
					</div>
				)) : (
					<span>
						<TextLabel value={"NoNotices"} />
					</span>
				)}
			</div>
		);
	}
}

export default WeekDay;
